import React, {Component} from 'react';
import {fetchStats} from '../services';
import googleChartLoader from '../GoogleChartLoader';
import Loader from '../Elements/Loader';

class SenderStateStats extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isCommunicatingWithServer: true,
            showError: false,
            rows: [],
            height: this.props.height ? parseInt(this.props.height, 10) : 400,
        };

        this.drawDashboard = this.drawDashboard.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }

    componentDidMount() {
        googleChartLoader.init(['corechart']);
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.rows.length !== this.state.rows.length) {
            googleChartLoader.init().then(() => {
                this.drawDashboard();
            });
        }
    }

    fetchData() {
        this.setState({
            isCommunicatingWithServer: true,
            showError: false,
            rows: [],
        });

        fetchStats('senderState')
            .then(data => {
                this.setState({
                    rows: data,
                    isCommunicatingWithServer: false
                });
            })
            .catch(() => {
                this.setState({
                    isCommunicatingWithServer: false,
                    showError: true,
                });
            });
    }

    drawDashboard() {
        const data = new window.google.visualization.DataTable();
        data.addColumn("string", 'State label');
        data.addColumn("number", 'State number');
        data.addRows(this.state.rows);

        const options = {
            title: 'Sender state',
            height: this.state.height,
            chartArea: {
                left: 50,
                right: 0,
                top: 30,
                bottom: 30,
            },
        };

        const chart = new window.google.visualization.PieChart(document.getElementById('SenderStateStats'));
        chart.draw(data, options);
    }

    render() {
        const height = this.state.height;

        return (
            <div id="SenderStateStatsWrapper">
                <div style={{height: height + 'px'}}>
                    {this.state.isCommunicatingWithServer && (
                        <div className="d-flex flex-column justify-content-center h-100 text-center">
                            <Loader/>
                        </div>
                    )}
                    {this.state.showError && (
                        <div className="d-flex flex-column justify-content-center h-100 text-center">
                            An error occured showing this graph. Try refreshing the page.
                        </div>
                    )}
                    <div id="SenderStateStats"/>
                </div>
            </div>
        );
    }
}

export default SenderStateStats;
